<template>
  <el-dialog :visible.sync="show"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="350px"
             top="30vh">
    <div class="confirm-container">
      <div class="confirm-tip">
        <span :class="type">!</span>{{ languages.permission.authConfirm }}
      </div>
      <div class="confirm-item">
        <div class="confirm-title">{{ languages.permission.auth }}:</div>
        <div class="confirm-desc">{{ apply.applyName }}</div>
      </div>
      <div class="confirm-item">
        <div class="confirm-title">{{ languages.permission.applyDst }}:</div>
        <div class="confirm-desc">{{ apply.pcName }}</div>
      </div>
      <div class="confirm-item">
        <div class="confirm-title">{{ languages.permission.applyUser }}:</div>
        <div class="confirm-desc">{{ apply.userName }}</div>
      </div>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <el-button class="button-cancel"
                 @click="Cancel">{{ languages.cancel }}</el-button>
      <el-button class="button-confirm"
                 type="primary"
                 :loading="submitting"
                 @click="Submit">{{
        languages.confirm
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  inject: ['gridTemplate'],
  props: {
    languages: Object,
    type: String,
    show: Boolean,
    apply: Object,
    submitting: Boolean,
  },
  methods: {
    Cancel () {
      this.gridTemplate.cancelApply();
    },
    Submit () {
      this.gridTemplate.submitApply();
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-title {
  width: 200px;
}
</style>
